import type { SiteStatus } from '../types';

const statusConfig: Record<SiteStatus, { label: string; className: string }> = {
  draft: { label: 'Draft', className: 'badge-draft' },
  building: { label: 'Building', className: 'badge-building' },
  live: { label: 'Live', className: 'badge-live' },
  error: { label: 'Error', className: 'badge-error' },
};

interface StatusBadgeProps {
  status: SiteStatus;
}

export default function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusConfig[status] || statusConfig.draft;
  return <span className={`status-badge ${config.className}`}>{config.label}</span>;
}
